export const getFaviconFormat = (filePath: string | undefined) => {
  if (isICO(filePath)) {
    return "image/x-icon";
  } else {
    return "image/png";
  }
};
export const isICO = (faviconUrl: string | undefined) => faviconUrl?.toLowerCase().endsWith(".ico");
